import { PUBLISH_STATUS_LABELS } from '@/lib/publishStatus';
import { cn } from '@/lib/utils';

const SHAPES = {
    draft: 'rounded-full border-[1.5px] border-amber-500',
    released: 'rounded-full bg-emerald-500',
    revising: 'rounded-full border-[1.5px] border-blue-500 bg-[linear-gradient(90deg,theme(colors.blue.500)_50%,transparent_50%)]',
    archived: 'rounded-[2px] bg-zinc-400',
};

/**
 * A publish status as a shape, readable without its colour: a hollow ring is
 * draft, a filled dot is released, a half-filled ring is revising (a release
 * is out, and the passport is open for editing again), a square is archived.
 * Anything else draws nothing. (A dashed ring breaks into two arcs at this
 * size and reads as a glitch.)
 *
 * The glyph names its status to a screen reader; `decorative` takes it out of
 * the accessibility tree where the status is already written beside it.
 */
export default function StatusGlyph({ status, decorative = false, className }) {
    if (!Object.hasOwn(SHAPES, status ?? '')) {
        return null;
    }

    const name = decorative ? { 'aria-hidden': 'true' } : { role: 'img', 'aria-label': PUBLISH_STATUS_LABELS[status] };

    return <span {...name} data-status-glyph={status} className={cn('inline-block size-2 shrink-0', SHAPES[status], className)} />;
}
